import { ALIGN, ButtonsContent } from "src/modules/pe-landing-module/data/interfaces"
import { IPrimitiveProps } from "../section/Primitive"
import ButtonPrimitive from "./ButtonPrimitive"
import { setHorizontalAlignToCSSRule, setVerticalAlignToCSSRule } from "../section/Section"
import { useEffect } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"

/* Protopia Ecosystem component */ 
const ButtonsPrimitive = (props: IPrimitiveProps): JSX.Element => { 
    const primitive: ButtonsContent = ( props.primitive || {} ) as ButtonsContent
    
    useEffect(() => {
        addCSSClass(
            `buttons-${primitive.id}`,
            `.buttons-${primitive.id} {
                ${setHorizontalAlignToCSSRule(primitive.horizontal_align || ALIGN.MIDDLE)}
                ${ setVerticalAlignToCSSRule(primitive.vertical_align || ALIGN.MIDDLE)}
                width: 100%!important;
            }`
        )
        return () => {
            removeCSSClass(`buttons-${primitive.id}`)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return <div className={`d-flex buttons-${primitive.id} flex-wrap w-100`} data-primitive-type={primitive["data-primitive-type"]}>
        {
            (primitive.items || []).map((button: any, i: number) => {
                return <ButtonPrimitive 
                    primitive={{
                        design_type: primitive.design_type,
                        i: i,
                        items: primitive.items || [],
                        horizontal_align: primitive.horizontal_align,
                        vertical_align: primitive.vertical_align, 
                        width: primitive.width, 
                        button_color: primitive.button_color, 
                        border_width: primitive.border_width, 
                        icon: primitive.icon, 
                        style: primitive.style,
                        labelStyle: primitive.labelStyle,
                        ...button, 
                        type: primitive.type,
                        animated: button.animated || primitive.animated,
                        animated_delay: button.animated_delay || primitive.animated_delay
                    }} 
                    i={i} 
                    key={i} 
                />
            })
        }
    </div>  
}
export default ButtonsPrimitive